import { Link, Stack } from "@mui/material";
import React from "react";

const MainPage: React.FC = () => {
    return (
        <div>
            <Stack padding={2} gap={2}>
                <Link href="/scene/globus">🌎 Globus</Link>
                <Link href="/scene/terrain">🖼️ Terrain</Link>
                <Link href="/scene/shadow-map">🌳 Shadow Map</Link>
                <Link href="/native-sandbox">💻 Native Sandbox (C# + WebAssembly)</Link>
            </Stack>
        </div>
    );
};

export default MainPage;